import api from "../axiosInstance";

export const getPartnershipDataAPI = async (payload) => {
  try {
    const response = await api.get(
      `/partnerShip/admin?page=${payload.pageNumber}&limit=${payload.limit}`
    );
    return response.data;
  } catch (err) {
    console.log(err);
  }
};
export const getSocialMediaAPI = async () => {
  try {
    const response = await api.get(`/socialMedia`);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const create_Partnership_API = async (payload) => {
  try {
    const response = await api.post(`/partnerShip/admin`, payload);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

// Delete
export const Delete_Partnership_API = async (partnerShip_ID) => {
  try {
    const response = await api.delete(
      `/partnerShip/admin?partnerShipId=${partnerShip_ID}`
    );
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

// Edit partnership
export const Edit_Partnership_API = async (payload) => {
  try {
    // {
    //   "partnerShipId": "60c72b2f9b1e8e3a2c0d5f90",
    //   "title": "this is title",
    //   "description": "this is description",
    //   "companyLogo": "https://example.com/logo.png",
    //   "partnerShipCompanyName": "Example Company",
    //   "deliverables": "Report, Analysis",
    //   "platForm": "Online",
    //   "amount": 5000
    // }
    const response = await api.put(`/partnerShip/admin`, payload);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

// Edit Partnership status
export const Edit_PartnershipStatus_API = async (payload) => {
  try {
    console.log(payload);
    const response = await api.put(
      `/partnerShip/adminbyStatus?${
        payload.partnerShipId ? `partnerShipId=${payload.partnerShipId}` : ""
      }${
        payload.status === 0 ||
        payload.status === 1 ||
        payload.status === 2 ||
        payload.status === 3
          ? `&status=${payload.status}`
          : ""
      }${payload.userId ? `&userId=${payload.userId}` : ""}${
        payload.rejectionResponse
          ? `&rejectionResponse=${payload.rejectionResponse}`
          : ""
      }`
    );
    return response.data;
  } catch (err) {
    console.log(err);
  }
};
